

import { GenericTextIds } from "../../constants/GenericTextIds";
import { BasicProperties } from "../BasicProperties";
import { Localize } from "@goodgamestudios/localization";

export class BasicStandardYesNoDialogProperties extends BasicProperties {
    public buttonLabel_yes: string = "Yes";
    public buttonLabel_no: string = "No";
    public copy: string = "";
    public title: string = "";
    public functionYes: Function;
    public functionNo: Function;
    public functionClose: Function;

    constructor(title: string, copy: string, functionYes: Function = null, functionNo: Function = null, functionClose: Function = null, buttonLabel_yes: string = "", buttonLabel_no: string = "") {
        super();
        this.functionClose = functionClose;
        this.functionYes = functionYes;
        this.functionNo = functionNo;

        if (buttonLabel_yes.length > 0) {
            this.buttonLabel_yes = buttonLabel_yes;
        }
        else {
            this.buttonLabel_yes = this.delegateText(GenericTextIds.BUTTON_YES);
        }

        if (buttonLabel_no.length > 0) {
            this.buttonLabel_no = buttonLabel_no;
        }
        else {
            this.buttonLabel_no = this.delegateText(GenericTextIds.BUTTON_NO);
        }

        this.title = title;
        this.copy = copy;
        // super();
    }

    protected delegateText(textId: string): string {
        return Localize.text(textId);
    }
}

